export const ROLES = {
    SUPER_USER: 1,
    EXTERNAL_RECRUITER: 2,
};

export const DEFAULT_ROLE = {
    id: ROLES.SUPER_USER,
};

/**
 * 🛡️ Permission Naming Convention
 *
 * To keep role-based permissions consistent, readable, and scalable, follow this format:
 *
 *   Format: <RESOURCE>_<ACTION>[_<SCOPE>]
 *
 *   ▸ RESOURCE:   The domain entity (e.g., CANDIDATE, COMPANY, LINQ_REQUEST)
 *   ▸ ACTION:     What the user is allowed to do (e.g., VIEW, CREATE, EDIT, DELETE, MANAGE)
 *   ▸ SCOPE (optional): A sub-context to add specificity (e.g., LIST, MANUAL, PARSED, LINKEDIN)
 *
 * ✨ Examples:
 *   CANDIDATE_VIEW_LIST          → View all candidates
 *   CANDIDATE_VIEW_SINGLE        → View one candidate (e.g., /candidate/view/:id)
 *   CANDIDATE_CREATE_PARSED      → Create candidate via parser
 *   COMPANY_VIEW_SINGLE          → View company profile
 *   USER_MANAGE                  → Admin-level access to user management
 *   CANDIDATE_VIEW_ALREADY_PARSED_CANDIDATES → View already parsed candidates 
 */
export const PERMISSION_KEYS = {
    // Candidate entity
    CANDIDATE_VIEW_LIST: "CANDIDATE_VIEW_LIST",
    CANDIDATE_VIEW_SINGLE: "CANDIDATE_VIEW_SINGLE",
    CANDIDATE_CREATE_MANUAL: "CANDIDATE_CREATE_MANUAL",
    CANDIDATE_CREATE_PARSED: "CANDIDATE_CREATE_PARSED",
    CANDIDATE_VIEW_ALREADY_PARSED_CANDIDATES: "CANDIDATE_VIEW_ALREADY_PARSED_CANDIDATES",

    // Company entity
    COMPANY_VIEW_LIST: "COMPANY_VIEW_LIST",
    COMPANY_VIEW_SINGLE: "COMPANY_VIEW_SINGLE",

    // Linq request entity
    LINQ_REQUEST_VIEW_LIST: "LINQ_REQUEST_VIEW_LIST",

    // External recruiter entity
    EXTERNAL_RECRUITER_VIEW_MANAGEMENT: "EXTERNAL_RECRUITER_VIEW_MANAGEMENT",
};

const {
    CANDIDATE_VIEW_LIST,
    CANDIDATE_VIEW_SINGLE,
    CANDIDATE_CREATE_MANUAL,
    CANDIDATE_CREATE_PARSED,
    COMPANY_VIEW_LIST,
    COMPANY_VIEW_SINGLE,
    LINQ_REQUEST_VIEW_LIST,
    CANDIDATE_VIEW_ALREADY_PARSED_CANDIDATES,
    EXTERNAL_RECRUITER_VIEW_MANAGEMENT,
} = PERMISSION_KEYS;

export const PERMISSIONS = {
    // PAGES
    [CANDIDATE_VIEW_LIST]: [ROLES.SUPER_USER, ROLES.EXTERNAL_RECRUITER],
    [CANDIDATE_VIEW_SINGLE]: [ROLES.SUPER_USER, ROLES.EXTERNAL_RECRUITER],
    [CANDIDATE_CREATE_MANUAL]: [ROLES.SUPER_USER, ROLES.EXTERNAL_RECRUITER],
    [CANDIDATE_CREATE_PARSED]: [ROLES.SUPER_USER, ROLES.EXTERNAL_RECRUITER],
    [CANDIDATE_VIEW_ALREADY_PARSED_CANDIDATES]: [ROLES.SUPER_USER],

    [COMPANY_VIEW_LIST]: [ROLES.SUPER_USER],
    [COMPANY_VIEW_SINGLE]: [ROLES.SUPER_USER],

    [LINQ_REQUEST_VIEW_LIST]: [ROLES.SUPER_USER],
    [EXTERNAL_RECRUITER_VIEW_MANAGEMENT]: [ROLES.SUPER_USER],
};
